import { Component, Mixins, Watch } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import { magic } from '@gig/magic-sdk';
import { MagicConfigMixin, SessionMixin } from '@gig/magic-common';
import {
    TIER_LEVELS,
    RUBY_TIER_ACHIEVED_REWARD,
} from '../loyalty/loyalty.constants';
import {
    IRewardHistoryResponse,
    RewardReason,
} from '@gig/magic-sdk/dist/adapter/rewards/history';
import {
    LOYALTY_NAMESPACE,
    getters as loyaltyGetters,
} from '../../store/modules/loyalty';
import { getTierCode, isBlackDiamondUser } from '../loyalty/loyalty.utils';

const loyaltyModule = namespace(LOYALTY_NAMESPACE);

@Component({
    name: 'loyalty-progress',
})
export default class LoyaltyProgress extends Mixins(
    MagicConfigMixin,
    SessionMixin
) {
    /**
     * User history rewards data
     */
    userHistoryRewardsData: IRewardHistoryResponse | null = null;

    @loyaltyModule.Getter('progress')
    loyaltyProgress!: ReturnType<typeof loyaltyGetters.progress>;

    @loyaltyModule.Getter('points')
    loyaltyPoints!: ReturnType<typeof loyaltyGetters.points>;

    @loyaltyModule.Getter('level')
    loyaltyLevel!: ReturnType<typeof loyaltyGetters.level>;

    @loyaltyModule.Getter('pointsNextLevel')
    pointsNextLevel!: ReturnType<typeof loyaltyGetters.pointsNextLevel>;

    @loyaltyModule.Getter('tier')
    loyaltyTier!: ReturnType<typeof loyaltyGetters.tier>;

    @Watch('user', { immediate: true, deep: true })
    @Watch('loyaltyTier')
    initData() {
        this.fetchUserRewardsData();
    }

    private async fetchUserRewardsData() {
        if (!this.isLoggedIn) {
            return;
        }
        if (this.loyaltyTier === TIER_LEVELS.RUBY) {
            const rewardsHistoryPromise: ReturnType<typeof magic.methods.rewards.history> = magic.invokeCached(
                30,
                magic.methods.rewards,
                'history'
            )({});
            this.userHistoryRewardsData = await rewardsHistoryPromise;
        }
    }

    get loyaltyTierCode() {
        return this.loyaltyTier !== null ? getTierCode(this.loyaltyTier) : '';
    }

    get hasClaimedRubyReward() {
        if (!this.userHistoryRewardsData) {
            return false;
        }
        const rubyRewardHistory =
            this.userHistoryRewardsData?.rewardHistory[
                RUBY_TIER_ACHIEVED_REWARD
            ] || [];
        return rubyRewardHistory.find(
            (row) => row.reason === RewardReason.EXCHANGE
        );
    }

    get shouldHideBar() {
        return (
            isBlackDiamondUser(this.user) ||
            this.hasClaimedRubyReward
        );
    }
}
